import { getMetaContent } from '@nn/psdl-utility/src/dom-helpers.js';

// BOOTSTRAP NN APP
$(function () {
  if (getMetaContent('PSDL_AUTO_INIT') === 'false') {
    return;
  }
  nn.init();
});
